import React from 'react';
import { connect } from 'redux-bundler-react';
import { BasicToolbarButton, BasicToolbarMenu, BasicToolbarMenuItem, BasicToolbarMenuDivider, BasicToolbarSubmenu } from '../../application-controls';
import AddGeoJsonButton from './add-geojson';
import AddShapefileButton from './add-shapefile';
class AddDataButton extends React.Component {
  constructor(props){
    super(props);
    this.errorHandler = this.errorHandler.bind(this);
  }

  errorHandler(msg){
    const { doFireNotification } = this.props;
    doFireNotification({
      title:'Add Data Error',
      message: msg,
      level: 'error'
    })
  }

  render(){
    return (
      <BasicToolbarButton
        enabled={true}
        iconClass="mdi mdi-library-plus"
        title="Add Data"
        onDeactivate={ () => {} }
      >
        <BasicToolbarMenu>
          <AddGeoJsonButton onError={ this.errorHandler }/>
          <AddShapefileButton onError={ this.errorHandler }/>
        </BasicToolbarMenu>
      </BasicToolbarButton>
    )
  }
}

export default connect(
  'doFireNotification',
  AddDataButton
);